// 导入封装好的axios实例
import request from './request'

const http = {
  /**
     * methods: 请求方式
     * url 请求地址
     * params 请求参数
     */
  get(url, params) {
    const config = {
      method: 'get',
      url: url
    }
    if (params) config.params = params
    return request(config)
  },
  post(url, data) {
    const config = {
      method: 'post',
      url: url,
      data
    }
    return request(config)
  },
  uploadFile(url,data) {
    return request({
      method: "post",
      data: data,
      url:url,
      headers: {
        "Content-Type": "multipart/form-data;",
      },
      transformRequest: [
        function () {
          return data;
        },
      ],
    });
  },
  put(url, params) {
    const config = {
      method: 'put',
      url: url
    }
    if (params) config.params = params
    return request(config)
  },
  delete(url, params) {
    const config = {
      method: 'delete',
      url: url
    }
    if (params) config.params = params
    return request(config)
  }
}
// 导出
export default http



// WEBPACK FOOTER //
// ./src/request/http.js